export default __webpack_public_path__ + "static/media/volunteers.7863bb0f.png";